export default "__VITE_ASSET__jQIhfr1D__"